import React from 'react'
import { useTranslation } from 'react-i18next'

import { FormikProps } from 'formik'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

import { calculateBreakpointWidth } from '../../../../../../../utils/helper/calculateBreakpointWidth'
import { SectionForm } from './SectionForm'

type FormFieldName = 'attachment' | 'description'

type Props = {
  formik: FormikProps<any>
  isRequestRunning: boolean
  isFormFieldValid: (name: FormFieldName) => boolean
  handleClose: () => void
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  getFormErrorMessage: (name: FormFieldName) => false | JSX.Element
  isUploadFileVisible: boolean
}

export const UploadAttachmentDialog: React.FC<Props> = ({
  formik,
  isRequestRunning,
  isFormFieldValid,
  handleClose,
  visible,
  setVisible,
  getFormErrorMessage,
  isUploadFileVisible,
}) => {
  const { t } = useTranslation()

  // header
  const header = (
    <>
      {t(
        'eInvoiceDetails.stepper.additionalDocuments.table.upload.dialog.title',
      )}
    </>
  )

  // footer
  const uploadButtonLabel = t(
    'eInvoiceDetails.stepper.additionalDocuments.table.upload.dialog.upload.label',
  )

  const footer = (
    <>
      <Button
        label={t(
          'eInvoiceDetails.stepper.additionalDocuments.table.upload.dialog.cancel.label',
        )}
        icon="pi pi-times"
        className="p-button-text w-full md:w-auto mb-1 md:mb-0"
        onClick={handleClose}
      />
      <Button
        label={uploadButtonLabel}
        icon="pi pi-check"
        className="w-full md:w-auto"
        onClick={formik.submitForm}
        type="submit"
        disabled={!formik.dirty || isRequestRunning}
      />
    </>
  )

  return (
    <>
      <Button
        label={t(
          'eInvoiceDetails.stepper.additionalDocuments.table.upload.label',
        )}
        onClick={() => setVisible(true)}
        icon="pi pi-upload"
        className="p-button-outlined mb-2"
      />

      <Dialog
        visible={visible}
        style={{ width: '45rem' }}
        breakpoints={{ [calculateBreakpointWidth(45)]: '90vw' }}
        header={header}
        footer={footer}
        onHide={handleClose}
        blockScroll
      >
        {isUploadFileVisible && (
          <SectionForm
            formik={formik}
            isFormFieldValid={isFormFieldValid}
            getFormErrorMessage={getFormErrorMessage}
          />
        )}
      </Dialog>
    </>
  )
}
